import { InfoCircleFilled } from "@ant-design/icons";
import { Alert, Button, Row, Typography } from "antd";
import { bind, startCase } from "lodash";
import React, { useMemo } from "react";
import FanOperationType from "src/consts/FanOperationType";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";

const { Text } = Typography;

interface NoticeCardProps{
  title: string;
  description: string;
  buttons?: React.ReactNode;
}

const NoticeCard : React.FC<NoticeCardProps> = ({ title, description, buttons }) => {

    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between',
            width: '100%', 
            height: '140px', 
            backgroundColor: '#E6F4FF', 
            border: '1px solid #91CAFF', 
            borderRadius: '12px',
            padding: '12px',
        }}>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <InfoCircleFilled style={{ fontSize: '24px', color: '#1777ff', marginRight: '12px' }} />
                <div style={{ display:'flex', flexDirection:'column'}}>
                  <Text strong>{title}</Text>
                  <div style={{ marginTop: '4px' }}>
                    {description}
                  </div>
                </div>
            </div>
            <div style={{ display:'flex', justifyContent:'center', gap:'12px' }}>
              {buttons}
            </div>
        </div>
    );
}

export default NoticeCard;